import { render, staticRenderFns } from "./OfficialHolidaysPlansTable.vue?vue&type=template&id=689423df&"
import script from "./OfficialHolidaysPlansTable.vue?vue&type=script&lang=js&"
export * from "./OfficialHolidaysPlansTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports